<template>
    <div class="pagebox">

        <!-- 顶部 -->
        <PHeader></PHeader>

        <!-- 新闻内容 -->
        <div class="noticediv">
            <div class="noticecon">
                <div class="tit">{{CollegeConstitutionData.Title}}</div>
                <div class="time"><span>年份：{{CollegeConstitutionData.Year||'-'}}</span><span>发布时间：{{CollegeConstitutionData.ReleaseTime?CollegeConstitutionData.ReleaseTime.substring(0,16):'-'}}</span></div>
                <div class="txt Class_RichTextContent" v-html="CollegeConstitutionData.Content"></div>
            </div>
        </div>

        <!-- 底部 -->
        <PFooter></PFooter>

    </div>
</template>
<script>
import PHeader from "@/components/Header.vue";
import PFooter from "@/components/Footer.vue";
import { getStore,setStore } from "@/utils/utils";
import API from "@/api/config";
export default{
    components:{
        PHeader,
        PFooter
    },
    data(){
        return{
            CollegeConstitutionData:{
                Title:'',
                ExamYear:'',
                CreateTime:''
            }
        }
    },
    mounted(){
        API.Query.GetCollegeNewsDetail({Id:this.$route.query.id}).then(res => {
            if(res.Code===0&&res.Data){
                this.CollegeConstitutionData = res.Data;
            }
        });
    },
    methods:{
        
    }
}
</script>
<style lang="less" scoped>
.noticediv{
    max-width: 1200px;
    margin: auto;
    .noticecon{
        margin: 30px 20px 30px;
        border: 1px solid #ddd;
        min-height: 600px;
        background-color: #fff;
        .tit{
            color: #444;
            font-size: 20px;
            line-height: 30px;
            margin: 20px 20px 0;
            text-align: center;
            font-weight: bold;
        }
        .time{
            text-align: center;
            color: #666;
            font-size: 14px;
            margin-top: 10px;
            border-bottom: 1px solid #ddd;
            padding-bottom: 10px;
            span{
                margin: 0 20px;
            }
        }
        .txt{
            color: #555;
            font-size: 14px;
            line-height: 24px;
            text-indent: 28px;
            margin: 20px 30px 30px;
            overflow: hidden;
        }
    }
}
</style>
<style lang="less">
.Class_RichTextContent img,.Class_RichTextContent video{
    width: auto;
    max-width: 100%;
    display: block;
}
</style>